import React from 'react';
import { useAds } from 'hooks/use-ads';
import { useSelector } from '@ecommerce/nest-ssr/common';

const AdConfig: React.FC = () => {
    const device = useSelector(
        (state: { device: string; }) => state.device
    );

    const config = useAds();

    if (!config?.enabled || config?.kwrd?.includes('adult')) {
        return null;
    }

    config.mobile = device === 'mobile' ? 1 : 0;

    return (
        <>
            <script
                dangerouslySetInnerHTML={{
                    __html: `
                        var dlApi = (${JSON.stringify(config || '{}')});
                        
                        const Opineo = {
                            Google: {}
                        };
                    
                        document.Opineo = Opineo;
                    `
                }}
            />
            <script src="//lib.onet.pl/s.csr/build/dlApi/dl.boot.min.js" async={true} />
            <script src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js" async={true} />
        </>
    );
};

export default AdConfig;
